/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Sales_Campaign_InvalidInputs */

const en_error_sales_campaign_invalid = /** @type {(inputs: Error_Sales_Campaign_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The campaign cannot be saved: check the fields marked.`)
};

/**
* | output |
* | --- |
* | "The campaign cannot be saved: check the fields marked." |
*
* @param {Error_Sales_Campaign_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_sales_campaign_invalid = /** @type {((inputs?: Error_Sales_Campaign_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Sales_Campaign_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_sales_campaign_invalid(inputs)
});